<div class="chart-container">
    <canvas baseChart class="chart" [data]="doughnutChartData" [type]="doughnutChartType" [options]="chartOptions"> </canvas>
</div>
